import Router from 'vue-router'
import Vue from 'vue'

import NotFound from '@/containers/NotFound'
import DefaultContainer from '@/containers/DefaultContainer'
import Login from '@/components/Login'
import Implementation from '@/components/Implementation'
import Signed from '@/components/Signed'
import Exit from '@/components/Exit'

const router = new Router({

  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  //  mode: 'history',
  routes: [
    {
      path: '/404',
      name: 'notfound',
      component: NotFound
    },

    {
          path: '/login/:id',
          name: 'login',
          component: Login
    },

    {
      path: '/',
      redirect: '/404',
      name: 'home',
      component: DefaultContainer,
      children: [
        // {
        //   path: '/login/:id',
        //   name: 'login',
        //   component: Login,
        //   meta: {
        //     guest: true
        //   }
        // },
        {
          path: '/eligibility',
          name: 'eligibility',
          component: () => import('@/components/Eligibility'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/agreement',
          name: 'implementation',
          component: Implementation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/signed',
          name: 'signed',
          component: Signed,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/not-eligible',
          name: 'not-eligible',
          component: () => import('@/components/NotEligible'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/exit',
          name: 'exit',
          component: Exit
        }
      ]

    }
  ]
})

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.guest)) {
      Vue.auth.destroyToken()
      if (Vue.auth.authenticated()) {
        next({ path: '/agreement' })
      } else {
        next()
      }
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!Vue.auth.authenticated()) {
        next({ path: '/login' })
      } else { next() }
    } else {
      next()
    }
  }
)

export default router
